import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import * as reportService from "../../utilities/services/report"
import Layout from "../../components/Layout"

const ReportValuedCustomers = () => {
  const { token } = useSelector(state => state.user)
  const lastOrderRef = useRef(null)
  const limitRef = useRef(null)
  const [customers, setCustomers] = useState([])
  const [filters, setFilters] = useState({
    offset: 0,
    limit: 10,
  })

  const getValuedCustomers = async () => {
    try {
      const query = new URLSearchParams(filters)
      const response = await reportService.getValuedCustomers(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setCustomers(response.customers)
    } catch (error) {
      setCustomers([])
    }
  }

  const handleSearch = () => {
    const where = {}

    if (lastOrderRef.current.value) where.last_order = moment(lastOrderRef.current.value).format("YYYY-MM-DD")
    if (limitRef.current.value) where.limit = limitRef.current.value

    setFilters({ offset: 0, ...where })
  }

  const handleReset = () => {
    setFilters({ offset: 0, limit: 10 })
    lastOrderRef.current.value = ''
    limitRef.current.value = ''
  }

  useEffect(() => {
    getValuedCustomers({})
  }, [])

  useEffect(() => {
    getValuedCustomers(filters)
  }, [filters])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Valued Customers</p>
          </div>

          <div className="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row">
                <div className="col-md-2">
                  <input ref={lastOrderRef} type="date" className="form-control form-control-sm rounded-3" name="last_order" id="last_order" />
                </div>
                <div className="col-md-2">
                  <input ref={limitRef} type="number" className="form-control form-control-sm rounded-3" name="limit" id="limit" placeholder="Limit" />
                </div>
                <div className="col-md-6" />
                <div className="col-md-2">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSearch}><i className="fas fa-search me-2"></i> Search</button>
                    <button type="reset" className="btn btn-sm btn-light-danger rounded-3" onClick={handleReset}><i className="fas fa-times me-2"></i> Clear</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive rounded-bottom-4">
              <table className="table table-sm table-hover shadow-none m-0">
                <thead className="table-light">
                  <tr>
                    <th scope="col" style={{ width: "7%" }} className="align-middle">Mobile</th>
                    <th scope="col" style={{ width: "8%" }} className="align-middle">Address</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle">Zone</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">First</small><br />Order</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Last</small><br />Order</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Length as</small><br />Customer<br /><small className="text-muted">in Months</small></th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Order Avg</small><br />Frequency<br /><small className="text-muted">in Days</small></th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Last</small><br />Not Ordered<br /><small className="text-muted">in 3 Months</small></th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle">Chaseable</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle">Delay<br /><small className="text-muted">in Days</small></th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Total</small><br />Orders</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Total</small><br />Value</th>
                    <th scope="col" style={{ width: "8%" }} className="align-middle"><small className="text-muted">Top</small><br />Product</th>
                    <th scope="col" style={{ width: "7%" }} className="align-middle"><small className="text-muted">Top</small><br />Product<br /><small className="text-muted">Qty</small></th>
                  </tr>
                </thead>
                <tbody>
                  {customers.map((order, index) => (
                    <tr key={index}>
                      <td className="align-middle">{order.mobile}</td>
                      <td className="align-middle">{order.address}</td>
                      <td className="align-middle">{order.zone_name}</td>
                      <td className="align-middle">{order.first_order_datetime && moment(order.first_order_datetime).format('DD MMM YYYY')}</td>
                      <td className="align-middle">{order.last_order_datetime && moment(order.last_order_datetime).format('DD MMM YYYY')}</td>
                      <td className="align-middle">{order.length_as_customer_months}</td>
                      <td className="align-middle">{order.avg_order_frequency_days?.toFixed(2)}</td>
                      <td className="align-middle">{order.not_ordered_last_3_months ? "Yes" : "No"}</td>
                      <td className="align-middle">{order.should_be_chased ? "Yes" : "No"}</td>
                      <td className="align-middle">{order.delayed_by_days}</td>
                      <td className="align-middle">{order.total_orders}</td>
                      <td className="align-middle">{order.total_value}</td>
                      <td className="align-middle">{order.top_product}</td>
                      <td className="align-middle">{order.top_product_quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default ReportValuedCustomers
